import React, { useCallback } from 'react';
import { View } from 'react-native';
import { useNavigation } from '@react-navigation/native';

import { useThemedStyles } from '../../../hooks/useThemedStyles';
import LocationSetupList from './LocationSetupList';
import { GET_LOCATION_SETUPS } from '../../../../common/graphql/locationSetup';
import { Button } from '../../../components';

const LocationSetupListView = () => {
	const styles = useThemedStyles(createStyles);
	const navigation = useNavigation();

	const handlePressItem = useCallback((item) => {
		if (item?.id) {
			navigation.navigate('LocationSetupDetailView', {
				locationSetupId: item.id,
			});
		}
	}, [navigation]);

	const handleOpenCreator = useCallback(() => {
		navigation.navigate('LocationSetupCreatorView');
	}, [navigation]);

	return (
		<View style={styles.container}>
			<LocationSetupList
				query={GET_LOCATION_SETUPS}
				initialSortBy="dueDate"
				initialSortDirection={-1}
				initialPerPage={15}
				listId="native_location_setups"
				customProps={{
					onPressItem: handlePressItem,
				}}
				customControls={(
					<Button
						label="New location setup"
						secondary={true}
						style={styles.createButton}
						onPress={handleOpenCreator}
					/>
				)}
			/>
		</View>
	);
};

const createStyles = ({ ui: { colors, space } }) => ({
	container: {
		flex: 1,
		backgroundColor: colors.canvas,
	},
	createButton: {
		marginLeft: space.sm,
	},
});

export default LocationSetupListView;
